import { render, staticRenderFns } from "./cfajml.vue?vue&type=template&id=da4be25a&scoped=true&"
import script from "./cfajml.vue?vue&type=script&lang=js&"
export * from "./cfajml.vue?vue&type=script&lang=js&"
import style0 from "./cfajml.vue?vue&type=style&index=0&id=da4be25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4be25a",
  null
  
)

export default component.exports